import * as apiTo from '@/modular-api'
import { getDefaultAddress } from '@/reusable/address-fields/default-address'

const initialState = () => ({
  publisher: null,
  createData: null
})

export default {
  namespaced: true,

  state: initialState(),

  getters: {
    publisher: state => state.publisher,
    mainAddress: state =>
      state.publisher.addresses.find(address => address?.address_type.name === 'main') || getDefaultAddress('main'),
    bankAddress: state =>
      state.publisher.addresses.find(address => address?.address_type.name === 'bank') || getDefaultAddress('bank')
  },

  mutations: {
    setPublisher: (state, payload) => (state.publisher = payload),
    setCreateData: (state, payload) => (state.createData = payload),
    updateUncompletedTodos: (state, count) => (state.publisher.incomplete_to_dos_count = count),
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    initData({ commit }, publisherId) {
      return Promise.all([
        apiTo.GET_PUBLISHER_CREATE(),
        apiTo.GET_PUBLISHER(publisherId),
        apiTo.GET_PUBLISHER_CONTACTS(publisherId)
      ]).then(([{ data: createData }, { data: publisher }, { data: contacts }]) => {
        commit('setCreateData', createData.result)
        commit('setPublisher', publisher.result)
        commit('provider-show/setContacts', contacts.result, { root: true })
      })
    },

    updatePublisher({ commit, state }, payload) {
      return apiTo.MODIFY_PUBLISHER(state.publisher.id, payload).then(({ data }) => {
        commit('setPublisher', data.result)
        return data.result
      })
    },

    updateField({ commit, dispatch, state }, { set, field, cancel, value, setLoading }) {
      setLoading(true)

      dispatch('updatePublisher', { [field]: value || null })
        .then(set)
        .catch(cancel)
        .finally(() => setLoading(false))
    }
  }
}
